import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { Plan } from '../../../models/quotation-model/catalogs/plan.model';
import {
  QuoterPlanPaged,
  QuoterPlan,
  QuoterPlanDeadlinePaged,
  QuoterPlanDeadline,
} from '../../../models/quotation-model/catalogs/quoterConfig/quoter-plan.model';
import { CommonFilterRequest, CommonResult } from '../../../models/quotation-model/customer.model';

@Injectable({
  providedIn: 'root',
})
export class PlanService {
  URL_API = environment.apiURL;
  constructor(private http: HttpClient) {}

  getPlans(modelId: number, brandId: number, planTypeId: number): Observable<Plan[]> {
    let condition: string;
    if (planTypeId == 1) {
      condition = 'CERRADO';
    } else {
      condition = 'ABIERTO';
    }
    return this.http.get<Plan[]>(
      this.URL_API + '/Plan?modelId=' + modelId + '&condition=' + condition + '&brandId=' + brandId,
    );
  }

  getPlansToDealer(dealerId: number): Observable<Plan[]> {
    return this.http.get<Plan[]>(this.URL_API + '/Plan/GetPlansToDealer?dealerId=' + dealerId);
  }

  getPagedPlans(filters: CommonFilterRequest): Observable<QuoterPlanPaged> {
    const params = new HttpParams()
      .set('page', filters.page.toString())
      .set('pageSize', filters.pageSize.toString())
      .set('sortActive', filters.sortActive)
      .set('sortDirection', filters.sortDirection)
      .set('filter', filters.filter ? filters.filter : '');
    return this.http.get<QuoterPlanPaged>(this.URL_API + '/Plan/GetPagedPlans', { params });
  }

  upsertQuoterPlan(upsertPlan: QuoterPlan) {
    return this.http.post<CommonResult>(this.URL_API + '/Plan/UpsertPlan', upsertPlan);
  }

  getPagedPlanDeadlines(
    filters: CommonFilterRequest,
    planId: number,
  ): Observable<QuoterPlanDeadlinePaged> {
    const params = new HttpParams()
      .set('page', filters.page.toString())
      .set('pageSize', filters.pageSize.toString())
      .set('sortActive', filters.sortActive)
      .set('sortDirection', filters.sortDirection)
      .set('filter', filters.filter ? filters.filter : '')
      .set('planId', planId);
    return this.http.get<QuoterPlanDeadlinePaged>(this.URL_API + '/Plan/GetPagedPlanDeadlines', {
      params,
    });
  }

  upsertQuoterPlanDeadline(upsertPlanDeadline: QuoterPlanDeadline) {
    return this.http.post<CommonResult>(
      this.URL_API + '/Plan/UpsertPlanDeadline',
      upsertPlanDeadline,
    );
  }
}
